import { onMounted, onUnmounted } from 'vue';

import { useAppStore } from '@/stores/app';

const handleBrowserTabFocus = () => {
  useAppStore().setBrowserTabState(true);
};

const handleBrowserTabBlur = () => {
  useAppStore().setBrowserTabState(false);
};

/** Следим за состоянием вкладки браузера у пользователя */
export const useAppBrowserTabState = () => {
  onMounted(() => {
    window.addEventListener('focus', handleBrowserTabFocus);
    window.addEventListener('blur', handleBrowserTabBlur);
  });

  onUnmounted(() => {
    window.removeEventListener('focus', handleBrowserTabFocus);
    window.removeEventListener('blur', handleBrowserTabBlur);
  });
};
